var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTwitter = function SvgTwitter(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    fill: "none",
    viewBox: "0 0 39 39",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M19.5 0C30.262 0 39 8.738 39 19.5S30.262 39 19.5 39 0 30.262 0 19.5 8.738 0 19.5 0m-3.435 29.871c8.63 0 13.348-7.15 13.348-13.347 0-.204 0-.408-.01-.603a9.6 9.6 0 0 0 2.344-2.432 9.5 9.5 0 0 1-2.695.74 4.7 4.7 0 0 0 2.063-2.598 9.5 9.5 0 0 1-2.977 1.138 4.67 4.67 0 0 0-3.424-1.478 4.69 4.69 0 0 0-4.69 4.689c0 .37.04.73.127 1.07a13.3 13.3 0 0 1-9.67-4.903A4.7 4.7 0 0 0 9.85 14.5a4.67 4.67 0 0 0 2.092 3.9 4.6 4.6 0 0 1-2.121-.583v.058a4.696 4.696 0 0 0 3.765 4.602 4.7 4.7 0 0 1-2.121.078 4.68 4.68 0 0 0 4.378 3.259 9.43 9.43 0 0 1-6.946 1.936 13.07 13.07 0 0 0 7.17 2.12",
    clipRule: "evenodd"
  })));
};
export default SvgTwitter;